// FUNCTION TO CONTROL DROPDOWNS ONLY IN NAVBAR MENUS
export function showNavbarDropdown(dropdown, content, index = 0) {
  const dropdownSelected = $(dropdown);
  const contentSelectedAll = $(content);
  const header = dropdownSelected.closest('header');
  const logoWhite = $('#logo-white');
  const logoBlue = $('#logo-blue');
  
  const formMain = $('.form-main');

  if (!dropdownSelected.length || !contentSelectedAll.length) {
    console.warn(`Dropdown elements not found for selector: ${dropdown}, ${content}`);
    return;
  }

  const contentSelected = $(contentSelectedAll[index]);

  if (!contentSelected.length) {
    console.warn(`No matching dropdown content found for index: ${index}`);
    return;
  }

  dropdownSelected.on('click', ({ target, currentTarget }) => {
    if (target.closest('.link.active') !== currentTarget) {
      header.addClass('home-style');
      header.removeClass('dropdown-active');
      header.find('.link.active').removeClass('active');
      header.find('.rotate-element').removeClass('rotate-element');
      header.find('.dropdown-active.d-flex').removeClass(['dropdown-active', 'd-flex']);
      logoWhite.addClass('d-none');
      logoBlue.removeClass('d-none');
      $('html').removeClass('scroll-lock');
    }

    dropdownSelected.find('i').toggleClass('rotate-element');
    dropdownSelected.toggleClass('active');
    $('html').toggleClass('scroll-lock');

    contentSelected.toggleClass('dropdown-active d-flex');

    header.toggleClass('home-style');
    header.toggleClass('dropdown-active');

    logoWhite.toggleClass('d-none');
    logoBlue.toggleClass('d-none');
  });

  window.addEventListener('click', ({ target }) => {
    if (target.closest('header')) {
      return;
    }

    if (formMain.hasClass('form-content-fixed')){
      $('html').addClass('scroll-lock');
    }

    if (header.hasClass('dropdown-active')){
      header.addClass('home-style');
      header.removeClass('dropdown-active');
      header.find('.link.active').removeClass('active');
      header.find('.rotate-element').removeClass('rotate-element');
      logoWhite.removeClass('d-none');
      logoBlue.addClass('d-none');
      contentSelected.removeClass(['dropdown-active', 'd-flex']);
      header.find('.dropdown-active.d-flex').removeClass(['dropdown-active', 'd-flex']);
      $('html').removeClass('scroll-lock');
    }
  });
}

// FUNCTION TO CONTROL DROPDOWNS ONLY IN SIDEBARS
export function showSidebarDropdown(dropSidebar, contentSidebar, indexSidebar) {
  const dropdownSelected = document.querySelector(dropSidebar);
  const contentSelected = document.querySelectorAll(contentSidebar);

  if(dropdownSelected) {
    const dropdownIcon = dropdownSelected.querySelector('i');

    dropdownSelected.addEventListener('click', () => {
      dropdownIcon.classList.toggle('rotate-element');
      dropdownSelected.parentNode.classList.toggle('active');
      dropdownSelected.classList.toggle('active');
      contentSelected[indexSidebar].classList.toggle('d-flex');

      if(contentSelected[indexSidebar].classList.contains('d-flex')) {
        const dropdownHeight = contentSelected[indexSidebar].offsetHeight;

      } else {
        dropdownSelected.style.removeProperty('margin-bottom');
      }
    });
  }
}
